module.exports = __webpack_public_path__ + "img/Task book Literacy.no.d2e513b9.png";